// mutations
const SCHOOLROUTES_REPORTS_ALL = (state, schoolroutesReports) => {
  if (schoolroutesReports.code === 1) {
    state.schoolroutesReports = schoolroutesReports.data
    state.status = 'success'
  } else {
    alert(schoolroutesReports.message)
    state.status = 'error'
  }
}

const SCHOOLROUTES_REPORTS_FORM = (state, schoolroutesReports) => {
  if (schoolroutesReports.code === 1) {
    state.schoolroutesReports = schoolroutesReports.data
    state.status = 'success'
  } else {
    alert(schoolroutesReports.message)
    state.status = 'error'
  }
}

const SCHOOLROUTES_REPORTS_SHOW = (state, schoolroutesReports) => {
  if (schoolroutesReports.code === 1) {
    state.schoolroutesReports = schoolroutesReports.data
    state.status = 'success'
  } else {
    alert(schoolroutesReports.message)
    state.status = 'error'
  }
}

const SCHOOLROUTES_REPORTS_CREATE = (state, schoolroutesReports) => {
  if (schoolroutesReports.code === 1) {
    state.schoolroutesReports = schoolroutesReports.data
    state.status = 'success'
  } else {
    alert(schoolroutesReports.message)
    state.status = 'error'
  }
}

const SCHOOLROUTES_REPORTS_UPDATE = (state, schoolroutesReports) => {
  if (schoolroutesReports.code === 1) {
    state.schoolroutesReports = schoolroutesReports.data
    state.status = 'success'
  } else {
    alert(schoolroutesReports.message)
    state.status = 'error'
  }
}

const SCHOOLROUTES_REPORTS_DELETE = (state, schoolroutesReports) => {
  if (schoolroutesReports.code === 1) {
    state.schoolroutesReports = schoolroutesReports.data
    state.status = 'success'
  } else {
    alert(schoolroutesReports.message)
    state.status = 'error'
  }
}

export default {
  SCHOOLROUTES_REPORTS_ALL,
  SCHOOLROUTES_REPORTS_FORM,
  SCHOOLROUTES_REPORTS_SHOW,
  SCHOOLROUTES_REPORTS_CREATE,
  SCHOOLROUTES_REPORTS_UPDATE,
  SCHOOLROUTES_REPORTS_DELETE
}



// WEBPACK FOOTER //
// ./src/store/modules/schoolroutes/reports/mutations.js